<div class="container">
  <app-general-header
    [title]="'Manage ' + ((district && district.title) || 'District')" />
  <div class="card border-0 p-3 pb-5">
    <app-settings-nav [districtCode]="districtCode" />

    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <div class="w-100 mt-4 px-xl-5" style="min-height: 400px">
        <div
          class="intro p-3 px-xl-4 ms-xl-5 d-flex flex-column flex-lg-row justify-content-between align-items-center">
          <div>
            <h2 class="fw-700" style="color: #430089">SmartAssistant</h2>
            <p>
              GroweLab’s Smart Assistant is an intelligent assistant
              specifically designed for K-12 education. Unlike general-purpose
              AI tools, Smart Assistant is trained on K-12 best practices and
              built exclusively to support the unique needs of school districts
              like yours.
            </p>
            <h2 class="fw-700 mt-4" style="color: #430089">
              Customize Your Smart Assistant
            </h2>
            <p>
              With Custom District Intelligence, you can upload and manage
              district-specific instructions, goals, resources, and documents to
              fully customize the Smart Assistant for your district’s unique
              needs. This ensures the AI aligns perfectly with your district's
              vision, policies, and priorities.
            </p>
          </div>
          <div class="ai-logo mx-5">
            <img
              src="/assets/icon-ai-assistant.svg"
              class="ai-icon"
              alt="AI Assistant" />
          </div>
        </div>

        <ng-container *ngIf="!kbIsLoading; else loadingTemplate">
          <ng-container *ngIf="districtKnowledgeBase; else notFound">
            <div class="w-100 pt-0 px-2 px-xl-5">
              <app-s3-file-explorer
                [knowledgeBase]="districtKnowledgeBase"
                (knowledgeBaseRefresh)="
                  getDistrictKnowledgeBase(district.id)
                " />
            </div>
          </ng-container>
          <ng-template #notFound>
            <div
              class="unlock-message mt-5 p-5 text-center mx-5 d-flex justify-content-center align-items-center"
              style="min-height: 300px">
              <div>
                <h3>Custom District Intelligence</h3>
                <p class="mt-3">
                  Add Custom District Intelligence to unlock customization.
                </p>
                <p>Contact your engage2learn project manager.</p>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #loadingTemplate>
      <div style="clear: both; height: 400px"></div>
      <app-loader />
    </ng-template>
  </div>
</div>
